import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";

// Component
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";

// API
import { updateTechnicianPerformance } from "@/DataPages/api/technicianFlaggedTime/mutations";
// Types
import { ITechnicianFlaggedTimeBase } from "@/DataPages/types/technicianFlaggedTime/model";

interface ITFTModelSwitch {
	technicianPerformance: ITechnicianFlaggedTimeBase | null;
}
export const TFTModelSwitch = (props: Readonly<ITFTModelSwitch>) => {
	const { technicianPerformance } = props;

	//States
	const [isFinalized, setIsFinalized] = useState(technicianPerformance?.isFinalized);

	const { mutate } = useMutation({
		mutationKey: ["updateTechnicianPerformance"],
		mutationFn: (input: { isFinalized: boolean }) =>
			updateTechnicianPerformance({
				locationId: technicianPerformance?.locationId ?? "",
				payPeriodId: technicianPerformance?.payPeriodId ?? "",
				commissionCycleId: technicianPerformance?.commissionCycleId ?? "",
				input,
			}),
	});

	const handleUpdateTechnicianPerformance = (value: boolean) => {
		if (!value) {
			setIsFinalized(false);
			mutate({ isFinalized: value });
		}
	};

	useEffect(() => {
		setIsFinalized(!!technicianPerformance?.isFinalized);
	}, [technicianPerformance?.isFinalized]);

	return (
		<CustomizedSwitches
			textRight={true}
			textChecked="Pay Period Finalized on DMS"
			textUnChecked="Pay Period Finalized on DMS"
			checked={isFinalized}
			disabled={!isFinalized}
			onChange={handleUpdateTechnicianPerformance}
		/>
	);
};
